<template>
  <div>
    <div v-if="showItems">
      <form-wrapper :validator="$v.items">

        <text-group
          :m="items"
          :input-cols="3"
          name="r11_prijmy"
          :label="$t('message.lblTuz64p')" />
        <text-group
          v-if="(r11_sposob_uctovania !=='percent')"
          :m="items"
          :input-cols="3"
          name="r11_vydavky"
          :label="$t('message.lblTuz64v')" />
        <b-button
          class="btn-primary"
          @click="save">
          {{ $t('message.lblSave') }}
        </b-button>

      </form-wrapper>
    </div>

    <no-sposob-checked
      v-if="showItems === false"
      :link-to="'sposobUctovania6o4'" />

  </div>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators';
import textGroup from '@/components/extractor/moneyTextGroup.vue';
import restEditor from '@/mixins/restEditor';
import noSposobChecked from '@/components/noSposobChecked.vue';

export default {
  components: {
    textGroup,
    noSposobChecked,
  },

  mixins: [restEditor],
  data() {
    const id = null;
    const parent = this.$route.params.userId;
    return {
      id,
      parent,
      showItems: null,
      r11_sposob_uctovania: null,
      items: {
        parent,
        r11_prijmy: null,
        r11_vydavky: null,
      },
    };
  },

  validations: {
    items: {
      r11_prijmy: {
        decimal,
        maxValue: maxValue(9999999.99),
        minValue: minValue(0),
      },
      r11_vydavky: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(9999999.99),
      },
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 6);
      if (this.id !== null) {
        const sposobData = await this.restDataSource.getDataSilent(this.id, 'par6sposob4');
        if (sposobData.r11_sposob_uctovania) {
          this.showItems = true;
          this.r11_sposob_uctovania = sposobData.r11_sposob_uctovania;
          this.items = await this.restDataSource.getData(this.id, 'par6inland4');
        } else {
          this.showItems = false;
        }
      } else {
        this.showItems = false;
      }
    },
    async processSave() {
      await this.restDataSource.updateData(this.items, 'par6inland4');
    },
  },

};
</script>

<style>
.form-row > .col, .form-row > [class*="col-"] {
    padding-right: 30px;
    padding-left: 0px;
}
.form-check-label {
    margin-bottom: 12px;
}
.form-check-inline .form-check-input {
    margin-top: -12px;
}
</style>
